// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--3I9534Cwo","changed":"changed--37Xx8M9Rp"};